function buildBody(agentId, perSession) {
    const body = { agent_id: agentId };
    if (perSession.identity !== undefined)
        body.participant_identity = perSession.identity;
    if (perSession.name !== undefined)
        body.participant_name = perSession.name;
    if (perSession.metadata !== undefined)
        body.participant_metadata = perSession.metadata;
    if (perSession.jobMetadata !== undefined) {
        body.job_metadata =
            typeof perSession.jobMetadata === 'string'
                ? perSession.jobMetadata
                : JSON.stringify(perSession.jobMetadata);
    }
    if (perSession.attrs !== undefined) {
        const attrs = parseStringRecord(perSession.attrs);
        if (attrs !== null)
            body.participant_attributes = attrs;
    }
    return body;
}
function parseStringRecord(value) {
    if (value === null || typeof value !== 'object' || Array.isArray(value))
        return null;
    const result = {};
    for (const [key, v] of Object.entries(value)) {
        if (typeof v !== 'string')
            return null;
        result[key] = v;
    }
    return result;
}
function parseConnectionDetails(value) {
    if (value === null || typeof value !== 'object')
        return null;
    if (!('serverUrl' in value) || typeof value.serverUrl !== 'string')
        return null;
    if (!('roomName' in value) || typeof value.roomName !== 'string')
        return null;
    if (!('participantName' in value) || typeof value.participantName !== 'string')
        return null;
    if (!('participantToken' in value) || typeof value.participantToken !== 'string')
        return null;
    return {
        serverUrl: value.serverUrl,
        roomName: value.roomName,
        participantName: value.participantName,
        participantToken: value.participantToken,
    };
}
// Standalone so the connect effect can re-mint at room.connect() time,
// avoiding the race where a cached token expires while the popup sits
// idle.
export async function mintConnectionDetails(apiBase, agentId, perSession, signal) {
    const response = await fetch(`${apiBase}/api/embed/connection-details`, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(buildBody(agentId, perSession)),
        signal,
    });
    if (!response.ok) {
        throw new Error(`mint failed: ${response.status}`);
    }
    const body = await response.json();
    const details = parseConnectionDetails(body);
    if (details === null) {
        throw new Error('mint response shape unexpected');
    }
    return details;
}
